import type { IconType } from "@components/material/Icon.module"
import { writable } from "svelte/store"

export type ToastType = {
    msg: string
    icon?: IconType
}

const DEFAULT_DURATION = 4000

export const Toasts = new (class {
    private _toasts = writable<Array<ToastType>>([])
    readonly subscribe = this._toasts.subscribe
    add(input: ToastType, duration?: number): void {
        const toast = { ...input }
        this._toasts.update((toasts) => {
            toasts.push(toast)
            return toasts
        })
        setTimeout(() => {
            this.remove(toast)
        }, duration || DEFAULT_DURATION)
    }

    error(msg: string) {
        this.add({ msg, icon: "circle-warning" })
    }

    remove(toast: ToastType): void {
        this._toasts.update((toasts) => {
            const idx = toasts.findIndex((ts) => ts === toast)
            if (idx !== -1) {
                toasts.splice(idx, 1)
            }
            return toasts
        })
    }

    clear(): void {
        this._toasts.set([])
    }
})()
